// ═══════════════════════════════════════════════════════════════
// ARCHIVO DESTINO: frontend/src/agenciaPicks.js
// ═══════════════════════════════════════════════════════════════
//
// El carrito de la agencia, en la forma que entienden las piezas
// compartidas del sportsbook.
//
// Las dos formas NO son la misma, y confundirlas pintaba cuotas como
// elegidas en partidos donde el cajero no había tocado nada.
//
// Un pick de la agencia es
// `{id:"Boca-River-Más de 2.5", home, away, sel, odd, ...}`: el `id` es
// compuesto y ya trae la etiqueta adentro, y el papel que en las piezas
// compartidas hace `label` acá lo hace `sel`.
//
// `CuotasCarrusel` y `MercadosEvento` marcan un resultado con
// `bets.some(b => b.id === ev.id && b.label === etiqueta)`, o sea con el
// id del EVENTO que se está dibujando.
//
// Lo que había en `FlujoManual` era `picks.map(p=>({id:ev.id,label:p.sel}))`:
// a CADA pick del carrito le pegaba el id del evento que se dibuja, sin
// mirar de qué partido venía. En el mostrador eso se veía así: el cajero
// toma "Más de 2.5" en Boca–River, abre los mercados de Milan–Inter, y
// ahí "Más de 2.5" aparece ya elegida. La toca para quitarla, `togglePick`
// arma la clave `Milan-Inter-Más de 2.5`, no la encuentra, y AGREGA una
// segunda selección. El botón sigue pintado, la cuota del combo cambió y
// nada se lo dijo.
//
// La regla no se inventa acá: la fija `togglePick` de `FlujoManual`, que
// es la verdad del carrito. Identifica un pick por
// `${home}-${away}-${label}`, así que un pick es de este evento cuando
// coinciden `home` y `away`. No hay una tercera regla. (`hasPick` leía
// esa misma clave para pintar la fila fija de 1X2; esa fila la reemplazó
// el carrusel, que pregunta por `bets`.)
//
// `h`/`a` y `home`/`away` se leen los dos porque las dos pantallas traen
// nombres distintos: el catálogo de `/api/live/prematch` usa `h`/`a` y el
// listado plano de `/api/live/combined` usa `home`/`away`. Es la misma
// lectura que ya hace `cuotasDeEvento.jsx`.
//
// La regla de "este pick es de este partido" sale a su propia función
// porque la necesita algo más que el adaptador: el T7 de
// sportsbook-homologado cuenta las selecciones del mismo partido para
// saber si todavía entra una más (ver `combosMismoPartido.js`). Si esa
// cuenta leyera los nombres por su cuenta habría una SEGUNDA regla, y el
// día que las dos no coincidan el cajero vería una selección marcada que
// el tope no cuenta.
export function picksDelPartido(picks, ev) {
  const home = (ev && (ev.h || ev.home)) || "";
  const away = (ev && (ev.a || ev.away)) || "";
  return (Array.isArray(picks) ? picks : [])
    .filter((p) => p && p.home === home && p.away === away);
}

export function picksDelEvento(picks, ev) {
  const id = ev && ev.id;
  return picksDelPartido(picks, ev).map((p) => ({ id, label: p.sel }));
}
